const Template = require('./template')

// execute the calendar based templates on the server to prevent the frontend
// from bogging down with running lots of templates on the calendar page
// this must be run BEFORE collapseCalendar (so we can still get at the templates)
const precomputeCalendarSlotTemplates = (calendar, config) => {
  calendar.forEach(day => {
    day.blocks.forEach(block => {
      block.slots.forEach(slot => {
        const template = Template({
          slot,
          config,
        })
        slot._calendarTemplates = {
          canBook: template(slot.templates.canBook, 'slot.templates.canBook'),
          title: template(slot.templates.title, 'slot.templates.title'),
          subtitle: template(slot.templates.subtitle, 'slot.templates.subtitle'),
        }
      })
    })
  })
  return calendar
}


// extract data from each slot and stash common values
// into a map that can be re-constituted on the frontend
const collapseCalendar = (calendar) => {
  let id = 0
  // content -> id
  const slotCacheTemp = {
    day: {},
    templates: {},
  }
  // id -> content
  const slotCache = {
    day: {},
    templates: {},
  }
  calendar.forEach(day => {
    day.blocks.forEach(block => {
      block.slots.forEach(slot => {
        const day = JSON.stringify(slot.day)
        const templates = JSON.stringify(slot.templates)
        const existingDayId = slotCacheTemp.day[day]
        if(!existingDayId) {
          id++
          slotCacheTemp.day[day] = id
          slot.day = id
        }
        else {
          slot.day = existingDayId
        }
        const existingTemplatesId = slotCacheTemp.templates[templates]
        if(!existingTemplatesId) {
          id++
          slotCacheTemp.templates[templates] = id
          slot.templates = id
        }
        else {
          slot.templates = existingTemplatesId
        }
      })
    })
  })

  Object.keys(slotCacheTemp.day).forEach(content => {
    const id = slotCacheTemp.day[content]
    slotCache.day[id] = JSON.parse(content)
  })

  Object.keys(slotCacheTemp.templates).forEach(content => {
    const id = slotCacheTemp.templates[content]
    slotCache.templates[id] = JSON.parse(content)
  })

  return {
    calendar,
    slotCache,
  }
}

// re-constitute the slot values using the cached values
const explodeCalendar = (calendar, slotCache) => {
  calendar.forEach(day => {
    day.blocks.forEach(block => {
      block.slots.forEach(slot => {
        slot.day = slotCache.day[slot.day]
        slot.templates = slotCache.templates[slot.templates]
      })
    })
  })
  return calendar
}

module.exports = {
  precomputeCalendarSlotTemplates,
  collapseCalendar,
  explodeCalendar,
}